
import React, { forwardRef, useEffect, useState, useMemo } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, parseSelectOptions } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const SeekerMappingForm = forwardRef(function SeekerMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { projectId, projectName } = props.record;
      return [{id: projectId, name: projectName }]
    }
    return [];
  });

  useEffect(() => {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(projects);
      }).catch((err)=>{
        message.error('Problem fetching projects')
      });
      
      return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { projectId } = config;
    return {
      projectId,
      projectName: projects.find(project => project.id === projectId)?.name
    };
  }

  const extraFields = useMemo(() => ([{
      name: 'projectId',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Project Name',
      options: parseSelectOptions(projects),
      required: true,
      props: {
        autoFocus: true
      }
    }
  ]), [projects]);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default SeekerMappingForm;